import { useState } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/features/auth/useAuth'
import { credentialsSchema } from '@/lib/validation/schemas'
import { env } from '@/env'

export function LoginPage() {
  const { session, signIn, error, loading } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [formError, setFormError] = useState<string | null>(null)
  const [submitting, setSubmitting] = useState(false)

  if (loading) return <p className="page-status">Loading…</p>
  if (session) return <Navigate to="/" replace />

  async function handleSubmit(event: { preventDefault: () => void }) {
    event.preventDefault()
    setFormError(null)

    const parsed = credentialsSchema.safeParse({ email, password })
    if (!parsed.success) {
      setFormError(parsed.error.issues[0]?.message ?? 'Check your details and try again.')
      return
    }

    setSubmitting(true)
    try {
      await signIn(parsed.data.email, parsed.data.password)
    } catch {
      // AuthProvider owns the user-facing message.
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <main className="auth-layout">
      <form className="auth-card" onSubmit={(e) => void handleSubmit(e)} noValidate>
        <h1>{env.appName}</h1>
        <p className="field-hint">Sign in to manage your events.</p>

        <label htmlFor="email">Email</label>
        <input
          id="email"
          type="email"
          autoComplete="username"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value)
          }}
          required
        />

        <label htmlFor="password">Password</label>
        <input
          id="password"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value)
          }}
          required
        />

        {(formError ?? error) && (
          <p className="field-error" role="alert">
            {formError ?? error}
          </p>
        )}

        <button type="submit" className="btn btn-primary" disabled={submitting}>
          {submitting ? 'Signing in…' : 'Sign in'}
        </button>

        <p className="field-hint">
          Admin accounts are created by invitation from an organization owner.
        </p>
      </form>
    </main>
  )
}
